import { Breadcrumb, Card, Col, message, Row, Space, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useReducer } from 'react';
import Plot from 'react-plotly.js';
import { DotChartOutlined, HomeOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import wellFieldsReducer from './reducer';
import { WELL_FIELDS_PLOT, WELL_FIELDS_PLOT_ERROR, WELL_FIELDS_PLOT_SUCCESS } from './constants';
import axios from 'axios';


const WellFieldView = () => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const { state } = useLocation();
	const navigate = useNavigate();

	const initalState = {FieldwellData : [], loading: false, error: false, updateData : {}};
	const [data, dispatch] = useReducer(wellFieldsReducer, initalState);	
	useAuth();

	useEffect(() => {
		loadFieldWellData();
	
	},[authtoken]);

	const loadFieldWellData =()=>{		
	
		if(state && state.data && state.data.wellFieldId ? state.data.wellFieldId: null){
					
			dispatch({ type : WELL_FIELDS_PLOT });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/well-field-cooridnates?wellFieldId=${state && state.data && state.data.wellFieldId ? state.data.wellFieldId: null}`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
									
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {	
																		
						dispatch({ type : WELL_FIELDS_PLOT_SUCCESS, payload : response });
					} 
					else {
						dispatch({ type : WELL_FIELDS_PLOT_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : WELL_FIELDS_PLOT_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}else{
			let response ={data:[]};
			dispatch({ type : WELL_FIELDS_PLOT_SUCCESS, payload : response });
		}
	
	};


	const plotdata = [
		{
			x: data && data.FieldwellData && data.FieldwellData.data?.prodctionwell?.Easting ? data.FieldwellData.data?.prodctionwell.Easting: [],
			y: data && data.FieldwellData && data.FieldwellData.data?.prodctionwell?.Northing ? data.FieldwellData.data?.prodctionwell.Northing: [],
			mode: 'markers',
			text: data && data.FieldwellData && data.FieldwellData.data?.prodctionwell?.name ? data.FieldwellData.data?.prodctionwell.name: [],
			name: langdata?.ProductionWell ?? 'Production Well',
			marker: { size: 15, color: 'red' },
			line: { color: 'red', width: 2 },
			type: 'scatter',
			hoverlabel: {
				bgcolor: 'rgba(255, 0, 0, 0.5)',
			},
			hovertemplate: `<b>${langdata?.ProductionWell ?? 'Production Well'}</b><br>${langdata && langdata.WellName ? langdata.WellName : 'Well Name'} : %{text}<br>${langdata?.EastingDistancem || 'Easting Distance (m)'} : %{x} <br>${langdata?.NorthingDistancem || 'Northing Distance (m)'} : %{y}<extra></extra>`
		},
		{
			x: data && data.FieldwellData && data.FieldwellData.data?.monitoringwell?.Easting ? data.FieldwellData.data?.monitoringwell.Easting: [],
			y: data && data.FieldwellData && data.FieldwellData.data?.monitoringwell?.Northing ? data.FieldwellData.data?.monitoringwell.Northing: [],
			text: data && data.FieldwellData && data.FieldwellData.data?.monitoringwell?.name ? data.FieldwellData.data?.monitoringwell.name: [],
			mode: 'markers',
			name: langdata?.MonitoringWells ?? 'Monitoring Wells',
			marker: { size: 10, color: 'blue'},
			hoverlabel: {
				bgcolor: 'rgba(0, 26, 255, 0.5)',
			},
			type: 'scatter',
			hovertemplate: `<b>${langdata?.MonitoringWells ?? 'Monitoring Wells'}</b><br>${langdata && langdata.WellName ? langdata.WellName : 'Well Name'} : %{text}<br>${langdata?.EastingDistancem || 'Easting Distance (m)'} : %{x} <br>${langdata?.NorthingDistancem || 'Northing Distance (m)'} : %{y}<extra></extra>`
		}
	];

	const shapes = [];


	const layout = {
		title: {
			text: state && state.data && state.data.FieldName ? state.data.FieldName : '',
			font: { size: 20, weight: 'bold' },
		},
		xaxis: {
			title: langdata?.EastingDistancem || 'Easting Distance (m)',
			range : [state && state.data && state.data.fieldminDistance ? state.data.fieldminDistance : -10 , state && state.data && state.data.fieldmaxDistance ? state.data.fieldmaxDistance : 10]
		},
		yaxis: {
			title: langdata?.NorthingDistancem || 'Northing Distance (m)',
			range : [state && state.data && state.data.fieldyminDistance ? state.data.fieldyminDistance : -10 , state && state.data && state.data.fieldymaxDistance ? state.data.fieldymaxDistance : 10]
		},
		shapes: shapes,
		
		legend: {
			font: {
				family: 'Arial, sans-serif',
				size: 12,
				color: 'black',
			}},
		margin: { t: 40, r: 40, l: 60, b: 60 },
	};
		
	shapes.push({
		type: 'rect',
		xref: 'paper',
		yref: 'paper',
		x0: 0,
		y0: 0,
		x1:  1,
		y1:  1,
		line: {
			color: 'black',
			width: 2,
		},
		layer: 'above',
	});


	data && data.FieldwellData.data?.monitoringwell?.Easting?.length > 0 && data.FieldwellData.data.monitoringwell.Easting.map((item, index)=>{
		shapes.push({
			
			type: 'line',
			x0: data && data.FieldwellData && data.FieldwellData.data?.prodctionwell?.Easting ? data.FieldwellData.data?.prodctionwell.Easting[0]: 0,
			y0: data && data.FieldwellData && data.FieldwellData.data?.prodctionwell?.Northing ? data.FieldwellData.data?.prodctionwell.Northing[0]: 0,
			x1: item ? item : 0,
			y1: data && data.FieldwellData.data?.monitoringwell?.Northing ? data.FieldwellData.data.monitoringwell.Northing[index]: 0,
			xref: 'x',
			yref: 'y',
			line: {
				color: 'green', 
				width: 2,
				dash: 'dashdot'
			},
			layer: 'above'

		});
	});


	
	
	return (

		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
		
				<Col span={8}>
					<Row>
						<Space>
							<DotChartOutlined style={{fontSize:'30px'}}/>
							{/* </Col> */}
						</Space>
						<Space>&nbsp;&nbsp;</Space>
							
						{/* <Col style={{marginLeft:'4px'}} span={19}> */}
						<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.FieldView ? langdata.FieldView : 'Field View'}</Title>
						
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							<Space>&nbsp;</Space>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{
				margin: '10px',
				// marginTop : '5px',
				// paddingLeft: '10px',
				// paddingRight: '10px',
				// background: '#FFFFFF',
				alignItems:'center',
			}}  >
				<Col span={18}>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title: ( state && state?.path === 'well-field' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.WellField ? langdata.WellField:'Well Field'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.WellField ? langdata.WellField:'Well Field'}</a>)
							},
							{
								title: `${langdata && langdata.FieldView ? langdata.FieldView : 'Field View'}`,
							},
						
						]}
						// style={{ marginBottom : '10px'}}
					/>
				</Col>
				<Col span={6} style={{ display : 'flex', justifyContent : 'flex-end'}}>
					{/* <Tooltip title={langdata && langdata.Graphlayout ? langdata.Graphlayout:'Graph layout'}>
						<Switch style={{backgroundColor: graphScroll == false ? '' : 'green'}} checkedChildren={langdata && langdata.Scroll ? langdata.Scroll:'Scroll'} unCheckedChildren={langdata && langdata.Fixed ? langdata.Fixed:'Fixed'} checked={graphScroll} onClick={handleSelectGraphScroll}/>
					</Tooltip> */}
				</Col>
			</Row>
			<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
				<Row style={{
					// margin: '10px',
					// marginBottom : '0px',
					// marginTop : '10px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// backgroundColor: '#ffffff',
					alignItems:'center',
				}} >
					<Col span={24}>	
							
						<Col>
							{/* <Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} > */}
							<>
								<Plot
									data={plotdata}
									layout={layout}

									style={{ width: '100%', height: '700px' }}
									config={{
										responsive: true,
										displayModeBar: true,
										displaylogo : false,
										modeBarButtonsToRemove: [],
									}}

									// onUpdate={(figure) => {
									// 	if (
									// 		figure.layout &&
									// 		figure.layout.sliders &&
									// 		figure.layout.sliders[0] &&
									// 		typeof figure.layout.sliders[0].active === 'number'
									// 	) {
									// 		const newOffset = vspSurveyOffsetsarray[figure.layout.sliders[0].active];
									// 		if (newOffset !== fieldOffset) {
									// 			handleSetFieldOffset(newOffset); // <-- triggers dropdown logic too
									// 		}
									// 	}
									// }}
								/>
							</>
								
						</Col>
						{/* </Spin> */}
					</Col>
				</Row>
			</Card> 

	
			<Spin fullscreen spinning={false} />
		</Content>
		
	);
};

export default WellFieldView;
